import React from "react";
import { NONQUAL_ACCOUNTS, PRETAX_ACCOUNTS, TAXFREE_ACCOUNTS } from "../../shared/constants";
import {
    currencyFormatNoDecimals,
    formatNumberToPercentage,
    INCOME_TYPES,
    isAccountRothConversionIntoFIA,
    PAYOUT_TYPES
} from "../../shared/shared";
import RoadmapOwnerCell from "./roadmapOwnerCell";

export const FiaTransfers = (props) => {
    const financialDataItemTHStyle = {
        paddingTop: "0.5em",
        paddingBottom: "0.5em",
        paddingLeft: "0.2em",
        paddingRight: "0.2em"
    };
    const financialDataItemTDStyle = {
        paddingTop: "0.5em",
        paddingBottom: "0.5em",
        fontSize: "0.9em",
        textAlign: "center"
    };
    const financialDataItemStyle = {
        display: "inline-block",
        width: "180px",
        marginRight: "1em"
    };
    const financialDataItemLabelStyle = {
        display: "inline-block",
        marginRight: "1em"
    };
    const subSectionStyle = { color: '#157ee8', margin: '25px 0', fontSize: "1em" }

    const getFIAPurpose = (item) => {
        if (item.rila) return "RILA";
        return item.annuityType ? item.annuityType.replaceAll("_", " ") : "";
    }

    const getAccountsAccountText = (element) => {
        if (element.fundingSourceType !== 'ACCOUNT') {
            return INCOME_TYPES[element.fundingSourceType];
        } else {
            let typeMap = {};
            const options = props.accounts.filter(item => {
                return item.appliesTo === element.appliesTo && item.id != null;
            }).map((item) => {
                if (typeMap[element.appliesTo + item.taxType + item.value]) {
                    typeMap[element.appliesTo + item.taxType + item.value].push(typeMap[element.appliesTo + item.taxType + item.value].length + 1);
                } else {
                    typeMap[element.appliesTo + item.taxType + item.value] = [1];
                }
                return item;
            }).map((item) => {
                const option =
                    item.taxType === "NON_QUALIFIED"
                        ? NONQUAL_ACCOUNTS.find((e) => e.value === item.accountType)
                        : item.taxType === "PRE_TAX"
                            ? PRETAX_ACCOUNTS.find((e) => e.value === item.accountType)
                            : TAXFREE_ACCOUNTS.find((e) => e.value === item.accountType);

                let text = "";
                if (option != undefined) {
                    text = option.text + " - " + currencyFormatNoDecimals(item.value)
                }
                if (typeMap[element.appliesTo + item.taxType + item.value].length == 1 && typeMap[element.appliesTo + item.taxType + item.value][0] == 1) {
                    typeMap[element.appliesTo + item.taxType + item.value].shift();
                } else if (typeMap[element.appliesTo + item.taxType + item.value].length > 0) {
                    text = text + " - " + typeMap[element.appliesTo + item.taxType + item.value][0];
                    typeMap[element.appliesTo + item.taxType + item.value].shift();
                }
                return {id: item.id, value: text};
            }).filter((item) => item.id === element.accountId);
            return options.length > 0 ? options[0].value : "";
        }
    }

    const CONVERSION_TYPE_LABELS = {
        "FIXED_AMOUNT": "Fixed",
        "ALL": "All"
    }

    return (<div>
        <h2 style={subSectionStyle}>FIA</h2>
        <table style={{
            width: "100%",
            borderCollapse: "collapse"
        }}>
            <thead>
                <tr style={{
                    backgroundColor: "#157ee8",
                    color: "white",
                }}>
                    <th style={financialDataItemTHStyle}></th>
                    <th style={financialDataItemTHStyle}>Tax type</th>
                    <th style={financialDataItemTHStyle}>Account Type</th>
                    <th style={financialDataItemTHStyle}>Owner</th>
                    <th style={financialDataItemTHStyle}>FIA Purpose</th>
                    <th style={financialDataItemTHStyle}>Payout</th>
                    <th style={financialDataItemTHStyle}>Funding Source</th>
                    <th style={financialDataItemTHStyle}>Transfer Amount</th>
                    <th style={financialDataItemTHStyle}>Transfer Start Year</th>
                    <th style={financialDataItemTHStyle}>Transfer End Year</th>
                    <th style={financialDataItemTHStyle}>Conversion Type</th>
                    <th style={financialDataItemTHStyle}># of Years</th>
                </tr>
            </thead>
            <tbody>
                {props?.fiaTransfers?.length > 0 && (
                    props.fiaTransfers.map((item, idx) => {

                        const optionAccountType =
                            item.taxType === "NON_QUALIFIED"
                                ? NONQUAL_ACCOUNTS.find((e) => e.value === item.accountType)
                                : item.taxType === "PRE_TAX"
                                    ? PRETAX_ACCOUNTS.find((e) => e.value === item.accountType)
                                    : TAXFREE_ACCOUNTS.find((e) => e.value === item.accountType);

                        return <React.Fragment key={idx}>
                            <tr>
                                    <td style={financialDataItemTDStyle}>{isAccountRothConversionIntoFIA(item, props.accounts) ? '⇅' : ''}</td>
                                    <td style={financialDataItemTDStyle}>{item.taxType.replaceAll("_", " ")}</td>
                                    <td style={financialDataItemTDStyle}>{optionAccountType?.text}</td>
                                    <td style={financialDataItemTDStyle}><RoadmapOwnerCell item={item}/></td>
                                    <td style={financialDataItemTDStyle}>{getFIAPurpose(item)}</td>
                                    <td style={financialDataItemTDStyle}>{item.annuityType === 'GUARANTEED_INCOME' ? PAYOUT_TYPES[item.payOutType] : ''}</td>
                                    <td style={financialDataItemTDStyle}>{getAccountsAccountText(item)}</td>
                                    <td style={financialDataItemTDStyle}>{currencyFormatNoDecimals(item.transferAmount)}</td>
                                    <td style={financialDataItemTDStyle}>{item.transferStartYear}</td>
                                    <td style={financialDataItemTDStyle}>{item.transferEndYear}</td>
                                    <td style={financialDataItemTDStyle}>
                                        {isAccountRothConversionIntoFIA(item, props.accounts) ? CONVERSION_TYPE_LABELS[item.conversionType] : ''}
                                    </td>
                                    <td style={financialDataItemTDStyle}>
                                        {isAccountRothConversionIntoFIA(item, props.accounts) ? item.noOfYears : ''}
                                    </td>
                            </tr>
                            <tr style={{
                                borderBottom: "1px solid #eee"
                            }}>
                                <td colSpan={10} style={{
                                    padding: "0.5em",
                                    fontSize: "0.7em"
                                }}>
                                    {!item.rila && (<React.Fragment>

                                        {item.annuityType === "VOLATILITY_BUFFER" && (
                                            <div style={financialDataItemStyle}>
                                                <label style={financialDataItemLabelStyle}>Premium Bonus</label>
                                                <span>{formatNumberToPercentage(item.premiumBonus, 2)}</span>
                                            </div>
                                        )}
                                        {item.annuityType === "VOLATILITY_BUFFER" && (<div style={financialDataItemStyle}>
                                            <label style={financialDataItemLabelStyle}>Upside</label>
                                            <span>{item.upsideType}</span>&nbsp;<span>{formatNumberToPercentage(item.upsideRate, 2)}</span>
                                        </div>)}
                                        {item.annuityType === "VOLATILITY_BUFFER" && (<div style={financialDataItemStyle}>
                                            <label style={financialDataItemLabelStyle}>Downside</label>
                                            <span>{item.downsideType}</span>&nbsp;<span>{formatNumberToPercentage(item.downsideRate, 2)}</span>
                                        </div>)}
                                        {item.annuityType !== "VOLATILITY_BUFFER" && (<div style={financialDataItemStyle}>
                                            <label style={financialDataItemLabelStyle}>Premium Bonus</label>
                                            <span>{formatNumberToPercentage(item.premiumBonus, 2)}</span>
                                        </div>)}
                                        {item.annuityType !== "VOLATILITY_BUFFER" && (<div style={financialDataItemStyle}>
                                        <label style={financialDataItemLabelStyle}>Hypothetical Index Return</label>
                                        <span>{formatNumberToPercentage(item.hypotheticalIndexReturn, 2)}</span>
                                    </div>)}
                                    {item.annuityType !== "VOLATILITY_BUFFER" && (
                                        <div style={financialDataItemStyle}>
                                            <label style={financialDataItemLabelStyle}>Years of Deferral</label>
                                            <span>{item.yearsOfDeferral}</span>
                                        </div>
                                    )}
                                    {item.annuityType !== "VOLATILITY_BUFFER" && (
                                        <div style={financialDataItemStyle}>
                                            <label style={financialDataItemLabelStyle}>Base Roll Up Rate</label>
                                            <span>{formatNumberToPercentage(item.baseRollUpRate, 2)}</span>
                                        </div>
                                    )}
                                    {(item.annuityType !== "VOLATILITY_BUFFER" && item.payOutType === "INCREASING") && (
                                        <div style={financialDataItemStyle}>
                                            <label style={financialDataItemLabelStyle}>Stacking Multiplier</label>
                                            <span>{formatNumberToPercentage(item.stackingMultiplier, 2)}</span>
                                        </div>
                                    )}
                                    {item.annuityType !== "VOLATILITY_BUFFER" && (
                                        <div style={financialDataItemStyle}>
                                            <label style={financialDataItemLabelStyle}>Benefit Base Bonus</label>
                                            <span>{formatNumberToPercentage(item.benefitBaseBonus, 2)}</span>
                                        </div>
                                    )}
                                    {(item.annuityType !== "VOLATILITY_BUFFER" && item.payOutType === "INCREASING") && (
                                        <div style={financialDataItemStyle}>
                                            <label style={financialDataItemLabelStyle}>Increasing Growth Multiplier</label>
                                            <span>{formatNumberToPercentage(item.increasingGrowthMultiplier, 2)}</span>
                                        </div>
                                    )}
                                    {item.annuityType !== "VOLATILITY_BUFFER" && (
                                        <div style={financialDataItemStyle}>
                                            <label style={financialDataItemLabelStyle}>Payout Factors</label>
                                            <span>{formatNumberToPercentage(item.payoutFactors, 2)}</span>
                                        </div>
                                    )}
                                    {(item.annuityType !== "VOLATILITY_BUFFER" && item.payOutType !== "INCREASING") && (
                                        <div style={financialDataItemStyle}>
                                            <label style={financialDataItemLabelStyle}>Payout COLA</label>
                                            <span>{formatNumberToPercentage(item.payoutCola, 2)}</span>
                                        </div>
                                    )}
                                    </React.Fragment>)}
                                    {item.rila && (
                                        <React.Fragment>
                                            <div style={financialDataItemStyle}>
                                                <label style={financialDataItemLabelStyle}>Upside</label>
                                                <span>{item.upsideType}</span>&nbsp;<span>{formatNumberToPercentage(item.upsideRate, 2)}</span>
                                            </div>
                                            <div style={financialDataItemStyle}>
                                                <label style={financialDataItemLabelStyle}>Downside</label>
                                                <span>{item.downsideType}</span>&nbsp;<span>{formatNumberToPercentage(item.downsideRate, 2)}</span>
                                            </div>
                                        </React.Fragment>
                                    )}
                                </td>
                            </tr></React.Fragment>
                    }))}
            </tbody>
        </table>
    </div>)

}
